'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _BackButton = require('components/BackButton/BackButton');

var _BackButton2 = _interopRequireDefault(_BackButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticsRecipientBackButton = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsRecipientBackButton, _PureComponent);

  function StatisticsRecipientBackButton() {
    (0, _classCallCheck3.default)(this, StatisticsRecipientBackButton);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientBackButton.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientBackButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsRecipientBackButton, [{
    key: 'getBackUrl',
    value: function getBackUrl() {
      var _props = this.props,
          referrer = _props.referrer,
          projectId = _props.projectId,
          recipientId = _props.recipientId;

      return referrer === 'recipient' ? '/statistics/recipient/' + recipientId : '/statistics/project/' + projectId;
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var backUrl = this.getBackUrl();

      return _react2.default.createElement(_BackButton2.default, {
        className: (0, _bind2.default)('margin-vert-20', className),
        asBlock: true,
        backUrl: backUrl
      });
    }
  }]);
  return StatisticsRecipientBackButton;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  projectId: _propTypes2.default.number,
  recipientId: _propTypes2.default.number,
  referrer: _propTypes2.default.string
}, _class.defaultProps = {
  referrer: 'project'
}, _temp);
exports.default = StatisticsRecipientBackButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsRecipientBackButton/StatisticsRecipientBackButton.js
// module id = 850
// module chunks = 1